import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import ReactCountryFlag from "react-country-flag";
import { X, ChevronDown } from "react-feather";
import { useState, useMemo } from "react";
import { useCookies } from "react-cookie";
import acceptLanguageParser from 'accept-language-parser';

import { t, init } from 'application-translator/dist/translate/translate.react.js';


// styles
const useStyles = makeStyles({
  footer: {
    padding: '2.5rem 2.5rem 3.2rem',
    display: 'grid',
    gap: '1.5rem',
    placeContent: 'center',
    textAlign: 'center',
    lineHeight: 1.5,
    fontSize: '.875rem',
    background: '#000',
    color: '#757575',
  },
  link: {
    fontSize: '.75rem',
    color: 'inherit',
    textDecoration: 'none',
  }
})

function Footer() {
  const classes = useStyles()
  const date = new Date()

  const [showLocales, setShowLocales] = useState(false);

  const [cookies, setCookie] = useCookies(["locale"]);

  const changeLocale = async (locale) => {
    setCookie("locale", locale, {
      maxAge: 365 * 24 * 60 * 60,
      sameSite: "strict",
      path: "/",
    });


    setShowLocales(false);
    postMessage(false);

    await init(`links/translations/${locale}.json`, () => {return locale});
    window.location.reload()
  };

  const toggleLocales = () => {
    setShowLocales((o) => {
      return !o;
    });

    console.log(showLocales)
  };

  const [countries, setCountries] = useState({
    en: {
      country: "US",
      language: "English",
    },
    ja: {
      country: "JP",
      language: "日本語",
    },
  });

  const getLocale = () => {
    const acceptLanguageHeader = navigator.languages.join(', ');
    const userLanguages = acceptLanguageParser.parse(acceptLanguageHeader);
    // If the user has a preferred locale in a cookie, use it
    const preferredLocale = cookies.locale;

    return preferredLocale
      ? preferredLocale
      : userLanguages[0]
        ? userLanguages[0].code
        : 'en';
  };

  return (
    <>
      <footer className={classes.footer}>
        <p>
          {t('Copyright')} &copy; {date.getFullYear()} {t('UBX Training All Rights Reserved.')}
          <br />
          {t('Other marks belong to their respective owners.')}
        </p>
        <p>
          <a href="/legal" className={classes.link}>
            {t('Privacy & Legal')}
          </a>
        </p>
        <p>
          <button
            className="inline-flex items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-blue py-4 sm:py-0"
            onClick={toggleLocales}
          >
            <ReactCountryFlag
              countryCode={
                countries[getLocale()]?.country || countries.en.country
              }
              style={{
                marginTop: "-2px",
              }}
              svg
            />
            <span className="text-opacity-40 ml-2 mr-1">
              {countries[getLocale()]?.language || countries.en.language}
            </span>
            <ChevronDown
              color="white"
              size={18}
              className={`transform ${showLocales ? "" : "rotate-180"}`}
            />
          </button>
        </p>

      </footer>
      <div
        className={`transform fixed bottom-0 left-0 right-0 z-50 bg-darkGrey px-8 md:px-16 transition duration-200 ease-in-out ${showLocales ? "translate-y-0" : "translate-y-full"
          }`}
      >
        <div className="md:container relative w-full flex items-center justify-start sm:justify-center space-x-3  sm:space-x-8 mx-auto pt-8 pb-4 md:pt-32 md:pb-24 lg:pb-28">
          {Object.keys(countries).map((countryKey, i) => {
            const { country, language } = countries[countryKey];
            return (
              <div className="col-span-1" key={i}>
                <button
                  className="text-white inline-flex items-center mb-4 lg:mb-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue"
                  onClick={() => changeLocale(countryKey)}
                >
                  <ReactCountryFlag
                    countryCode={country}
                    svg
                    style={{
                      width: "1.2em",
                      height: "1.2em",
                      marginTop: "1px",
                    }}
                  />
                  <span className="ml-3">{language}</span>
                </button>
              </div>
            );
          })}
          <button
            className="absolute top-0 right-0 mt-8 md:mt-16 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-blue"
            onClick={toggleLocales}
          >
            <X color="white" size={24} />
          </button>
        </div>
      </div>
      <button
        onClick={toggleLocales}
        className={`fixed inset-0 z-40 bg-black transition duration-200 ease-in-out ${showLocales
          ? "bg-opacity-50 cursor-pointer"
          : "pointer-events-none bg-opacity-0"
          }`}
      />
    </>
  )
}

export default Footer
